import { Button } from '@material-ui/core';
import { Theme, withStyles } from '@material-ui/core/styles';

const UpdateBookingButton = withStyles((theme: Theme) => ({
  root: {
    background: theme.palette.secondary.main,
    color: theme.palette.common.black,
    padding: theme.spacing(0.5, 2),
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
    '&$focused': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  label: {
    textTransform: 'capitalize',
  },
}))(Button);

export default UpdateBookingButton;